import React, { Component } from 'react';
import { Container, Button, Alert } from 'react-bootstrap';
import ConfirmModal from 'components/controls/confirmModal';
import Navigation from "context/nav";
import Utils from "context/utils";

export default class Admin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modifying: false,
      deleting: false,
      deletionError: null,
      confirmModalShow: false
    };
  }

  handleDelete = () => {
    this.setState({
      modifying: true,
      deleting: true,
      deletionError: null
    });

    // Delete organization
    const orgId = this.props.org.id;
    this.props.app.api.orgsIdDelete(orgId)
      .then(response => {
        this.setState({
          modifying: false,
          deleting: false,
          deletionError: null
        });

        // Navigate to user profile page
        Navigation.push(this.props.history, Navigation.selfUserProfilePath());
      }, error => {
        // Indicate error
        this.setState({
          modifying: false,
          deleting: false,
          deletionError: error.message
        });
      });
  }

  render() {
    return (
      <>
        <h5>Delete Organization</h5>
        <hr/>
        <div>
          Organization removal cannot be reversed or undone. All blobs currently present in the organization will be
          removed along with it. Please double check that the organization you are about to remove is no longer used and
          its data is backed up.
        </div>
        {this.state.deleting &&
          <div className="content-row">
            <Alert variant="primary">
              Scheduling organization deletion...
            </Alert>
          </div>
        }
        {this.state.deletionError &&
          <div className="content-row">
            <Alert variant="warning">
              {this.state.deletionError}
            </Alert>
          </div>
        }
        {!this.state.modifying &&
          <div className="content-row">
            <Button
              type="submit"
              variant="success"
              size="sm"
              onClick={() => this.setState({confirmModalShow: true})}>
              Delete Organization
            </Button>
          </div>
        }

        <ConfirmModal
          show={this.state.confirmModalShow}
          onHide={() => this.setState({confirmModalShow: false})}
          onConfirm={this.handleDelete}
          title="Delete Organization"
          body={
            <>
              Are you sure you want to delete <strong>{Utils.displayName(this.props.org)}</strong>?
              This permanently and irreversibly removes the organization and all of its blobs.
            </>
          }
        />
      </>
    );
  }
}
